import { PERISCOPE_PROFILES_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { SonarRecord } from '@ui/records';
export const PeriscopeProfile = ({ item }) => {
    const accessInfo = item.hasEditAccess ? PERISCOPE_PROFILES_COPY.EDIT_ACCESS : PERISCOPE_PROFILES_COPY.READ_ACCESS;
    return (React.createElement(SonarRecord, { isActive: item.isActive, name: item.displayName, secondaryInfo: accessInfo, sonarObjectId: item.sonarObjectId }));
};
